import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const busicon = '/assets/ivergrama/Home/Bus Icon.png';

const busnorteiconone = '/assets/norte/Home/busnorteiconone.svg';
const busnorteicontwo = '/assets/norte/Home/busnorteicontwo.svg';
const busnorteiconthree = '/assets/norte/Home/busnorteiconthree.svg';
const busnorteiconfour = '/assets/norte/Home/busnorteiconfour.svg';


const aeroquintaiconone = '/assets/aeroquinta/Home/aeroquintaiconone.svg';
const aeroquintaicontwo = '/assets/aeroquinta/Home/aeroquintaicontwo.svg';
const aeroquintaiconthree = '/assets/aeroquinta/Home/aeroquintaiconthree.svg';
const aeroquintaiconfour = '/assets/aeroquinta/Home/aeroquintaiconfour.svg';



const torresiconone = '/assets/torres/homepage/iconone.svg';
const torresicontwo = '/assets/torres/homepage/icontwo.svg';
const torresiconthree = '/assets/torres/homepage/iconthree.svg';
const torresiconfour = '/assets//torres/homepage/iconfour.svg';

const ivergramaIconsAndTexts = [
	{ image: busicon, title: 'Rapidez', line: true, caption: 'Nuestros servicios tienen una menor duración ya que el bus no realiza paradas en el camino a no ser que sean paraderos establecidos.' },
	{ image: busicon, title: 'Puntualidad', line: true, caption: 'Sabemos que debes llegar a tiempo a tu destino, es por ello que te garantizamos nuestra puntualidad y responsabilidad en cada viaje.' },
	{ image: busicon, title: 'Confort', line: true, caption: 'Los salones de nuestros buses cuentan con aire acondicionado, cargador usb, wifi, asientos tipo cama y entretención televisiva.' },
	{ image: busicon, title: 'Limpieza', line: false, caption: 'Nuestros buses son sinónimo de limpieza, ya que entendemos la importancia de brindarte un entorno cómodo y saludable.' },
];
const aeroquintaIconsAndTexts = [
	{ image: aeroquintaiconone, title: 'Servicio al aeropuerto', line: true, caption: 'Estamos enfocados en dar solución a un servicio de traslado expreso entre Viña del mar y el aeropuerto de Santiago, de forma segura, eficiente y regulada.' },
	{ image: aeroquintaicontwo, title: 'Sólida trayectoria', line: true, caption: 'Contamos con más de 14 años de experiencia en transporte de pasajeros, avalados siempre por un servicio serio y fiable para todos nuestros clientes.' },
	{ image: aeroquintaiconthree, title: 'Conductores expertos', line: true, caption: 'Equipo altamente profesional y capacitados que priorizan la seguridad de los pasajeros, además destacando su amabilidad para que cada viaje sea un agrado.' },
	{ image: aeroquintaiconfour, title: 'Puntualidad y compromiso', line: false, caption: 'Nos comprometemos a respetar los horarios de salida para que llegues a tiempo a tu destino.' },
];
const norteIconsAndTexts = [
	{ image: busnorteiconone, title: 'Moderna flota', line: true, caption: 'Descubre nuestros modernos buses, garantía de comodidad, seguridad y eficiencia en cada trayecto. Con tecnología innovadora te ofrecemos la mejor experiencia.' },
	{ image: busnorteicontwo, title: 'Cómodos asientos', line: true, caption: 'Nuestra flota cuenta con asientos reclinables tipo Salón Cama para que viajes con total comodidad sin importar el destino al que vayas.' },
	{ image: busnorteiconthree, title: 'Servicios a bordo', line: true, caption: 'Los salones de nuestros buses cuentan con aire acondicionado, cargador usb, cortinas divisorias, baños higienizados y la mejor atención de nuestro equipo. ' },
	{ image: busnorteiconfour, title: 'Limpieza', line: false, caption: 'Somos sinónimo de limpieza y cuidado, ya que entendemos la importancia de brindarte un entorno cómodo y saludable.' },
];
const basetorresIconsAndTexts = [
	{ image: torresiconone, title: 'Comodidad', line: true, caption: 'Nuestros buses ofrecen espacios amplios y asientos ergonómicos, diseñados para que viajes relajado y con suficiente espacio para tu equipaje.' },
	{ image: torresicontwo, title: 'Compromiso', line: true, caption: 'Contamos con un equipo de conductores profesionales y un personal asistente capacitado, amable y comprometido con ofrecer un servicio seguro y de calidad.' },
	{ image: torresiconthree, title: 'Puntualidad ', line: true, caption: 'Sabemos que debes llegar a tiempo a tu destino, es por ello que te garantizamos nuestra puntualidad y responsabilidad en cada viaje.' },
	{ image: torresiconfour, title: 'Bilingüe', line: false, caption: ' Te ofrecemos la posibilidad de recibir instrucciones tanto en español como en inglés, para que disfrutes de una experiencia más completa y accesible.' },
];
const getIconsAndTexts = operator => {
	const name = operator && operator.operator_name;
	if (name === 'ivergrama') {
		return ivergramaIconsAndTexts;
	} else if (name === 'busnorte') {
		return norteIconsAndTexts;
	} else if (name === 'aeroquinta') {
		return aeroquintaIconsAndTexts;
	} else if (name === 'basetorres') {
		return basetorresIconsAndTexts;
	} else {
		return [];
	}
};

const ThemeThreeIconsSection = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	const renderIconsAndText = (item, index, length) => {
		const name = operator && operator.operator_name;
		if (name === 'ivergrama') {
			return (
				<div key={index} className='single-item' style={item.line ? { borderRight: '2px solid black' } : {}} >
					<img src={item.image} alt="Giras de estudio" style={{ width: '40px' }} />
					<div className='title less-bold-text'>{item.title}</div>
					<p className="caption">{item.caption}</p>
				</div>
			);
		}
		else if (name === 'aeroquinta') {
			return (
				<div key={index} className='single-item' style={item.line ? { borderRight: '3px solid #4078bc' } : {}} >
					<img src={item.image} alt="Giras de estudio" style={{ width: '30px', height: "40px" }} />
					<div className='title less-bold-text '>{item.title}</div>
					<p className="caption">{item.caption}</p>
				</div>
			);
		}
		else if (name === 'basetorres') {
			return (
				<div key={index} className='single-item' style={item.line ? { borderRight: '3px solid #4f7390' } : {}} >
					<img src={item.image} alt="Giras de estudio" style={{ width: '30px', height: "40px" }} />
					<div className='title less-bold-text '>{item.title}</div>
					<p className="caption">{item.caption}</p>
				</div>
			);
		}
		else if (name === 'busnorte') {
			return (
				<div key={index} className='single-item' style={item.line ? { borderRight: '3px solid #D9D528' } : {}} >
					<img src={item.image} alt="Giras de estudio" style={{ width: '40px', height: '40px' }} />
					<div className='title less-bold-text'>{item.title}</div>
					<p className="caption">{item.caption}</p>
				</div>
			);
		}
	};

	return (
		<div className="themes-theme-three-icons-section new-container" style={{ marginBottom: 55 }}>
			{getIconsAndTexts(operator).map((item, index) => {
				return renderIconsAndText(item, index, getIconsAndTexts(operator).length);
			})}
		</div>
	);
};



/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeThreeIconsSection);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeIconsSection.js